import React, {ReactElement, ReactNode} from "react";
import {observer} from "mobx-react-lite";
import classNames from "classnames";


import {IconProps} from "../icons";
import {ButtonProps} from "../Button";


import {screenSizeProvider} from "../../../stores/ScreenSizeProvider";


import "./EmptyPage.css"


interface EmptyPageProps {
    className?: string,
    Icon?: React.ComponentType<IconProps>;
    text: ReactNode,
    title?: ReactNode,
    button?: ReactElement<ButtonProps>,
    maxWidth?: number,
    additionalButton?: ReactElement<ButtonProps>,
    isImportantTitle?: boolean,
    helperText?: ReactNode,
}

export const EmptyPage = observer((
    {
        Icon,
        text,
        title,
        button,
        className,
        maxWidth,
        additionalButton,
        helperText,
        isImportantTitle = false
    }: EmptyPageProps
) => {
    const isMobile = screenSizeProvider.view !== 'desktop';
    return (
        <div className={classNames({
            "EmptyPage": true,
            [className!]: className,
        })}
             style={!isMobile ? {maxWidth: maxWidth} : undefined}>
            {Icon &&
                <Icon size={48} className={"EmptyPage__icon"}/>
            }
            {title &&
                <div className={classNames({
                    "EmptyPage__header headline-small-bold": !isImportantTitle,
                    "EmptyPage__importantHeader display-small-bold": isImportantTitle,
                    "title-large-bold": isMobile
                })}>
                    {title}
                </div>
            }
            <div className="EmptyPage__text body-large">
                {text}
            </div>
            <div className="EmptyPage__buttons">
                {button &&
                    <div className="EmptyPage__button">
                        {button}
                    </div>
                }
                {additionalButton &&
                    <div className="EmptyPage__button">
                        {additionalButton}
                    </div>
                }
            </div>
            {helperText &&
                <div className="EmptyPage__helperText title-medium">
                    {helperText}
                </div>
            }
        </div>
    );
})
